import { ADVENTURE_GREEN, SENSATION_WHITE } from '../colors'; // Specifies style of text selection

export var baseSelectionStyle = "\n  ::selection, *::selection {\n    color: " + SENSATION_WHITE + ";\n    background-color: " + ADVENTURE_GREEN + ";\n  }\n";